<template>
    <div class="waste">
        <div class="title">
            <div class="title-text">废水监测</div>
        </div>
        <div class="waste-box">
            <div class="waste-left">

            </div>
            <ul class="waste-right">
                <li>COD：73</li>
                <li>氨氮：59%</li>
                <li>水中油：69%</li>
                <li>废水流量：78T</li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "waste"
    }
</script>

<style scoped lang="less">
    .waste-box{
       width: 90%;
        display: flex;
        justify-content: space-between;
        font-family: sy;
        font-size: 12px;
        .waste-left{
            width: 43%;
            height: 13vh;
            background: url('./../../assets/img/radios.png') no-repeat;
            background-size: 100% 100%;
        }
        .waste-right{
            width: 40%;
            padding: 0;
            margin: 0;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            height: 70%;
            margin-top: 6%;
            li{
                width: 100%;
                margin-bottom: 5%;
            }
            li:nth-child(1){
                color: #98fef9;

            }
            li:nth-child(2){
                color: #fffeb7;
            }
            li:nth-child(3){
                color: #ff9600;
            }
            li:nth-child(4){
                color: #30c74d;
            }
        }
    }
</style>